<app-content-body [isCentralized]='true' height='90vh'>

    <div class="container">
        <div class="row d-flex justify-content-center py-5">
            <div class="col-md-5 border rounded shadow-sm p-4">
                <img class="img-fluid mb-4 logoheight" src="https://www.alachisoft.com/images/logo-d.svg"
                    alt="NCache" />
                <form [formGroup]="form" (ngSubmit)="onSubmit(verificationOTPModal)">
                    <div class="form-group ">
                        <h2 class="passwordlabel">Set Password</h2>
                        <p class="mb-4">Since this is your first time logging in, we need you to set up a password for <span class="text-blue">{{ this.email }}</span>. Please create a new password that you will use to access your account in the future.</p>
                        <div class="input-group">
                            <input type="password" [disabled]="loading" [type]="passwordShow ? 'text' : 'password'"
                                formControlName="password" class="form-control" placeholder="Enter Password"
                                appAutoFocus [ngClass]="{ 'is-invalid': submitted && f.password.errors }" autofocus/>
                            <div (click)="onPasswordShowClick('passwordShow')" class="pointer input-group-addon d-flex align-items-center px-2 border border-secondary border-left-0 bg-light-grey passwordShowBox">
                                <i class="fa pointer" [ngClass]="passwordShow === false ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
                            </div>
                            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                <div *ngIf="f.password.errors.required">Password is required</div>
                                <div *ngIf="f.password.errors.pattern">Password must be at least Eight characters long and must contain at least One Uppercase, One Lowercase and One
                                    Number</div>
                            </div>
                        </div>
                        <div class="input-group mt-3">
                            <input type="password" [disabled]="loading" [type]="passwordConfirmShow ? 'text' : 'password'"
                                formControlName="confirmPassword" class="form-control" placeholder="Confirm Password"
                                [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }" />
                            <div (click)="onPasswordShowClick('passwordConfirmShow')" class="pointer input-group-addon d-flex align-items-center px-2 border border-secondary border-left-0 bg-light-grey passwordShowBox">
                                <i class="fa pointer" [ngClass]="passwordConfirmShow === false ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
                            </div>
                            <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                                <div *ngIf="f.confirmPassword.errors.required">Confirm Password is required</div>
                                <div *ngIf="f.confirmPassword.errors.confirmedValidator">Password and Confirm Password must match</div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mt-4">
                    <button type="button" [disabled]="loading" (click)="redirectToPreviousPage($event)" class="ml-0 pl-0 btn btn-link">Go Back</button>
                    <button [disabled]="loading" class="btn btn-primary mt-2 float-right">
                        <span style="visibility: hidden;">a</span>
                        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        Save
                        <span style="visibility: hidden;">a</span>
                    </button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <ng-template #creatingSubscription>
        <span class="spinner-border spinner-border-sm mr-2"></span> Creating subscription.
    </ng-template>

    <ng-template #verificationOTPModal let-modal>
        <div>
            <h4 class="font-weight-bold p-4 m-0">Verify Email Address</h4>
            <hr class="m-0">
            <div class="p-4">
                <p style="font-size: 1rem;" class="m-0">A verification OTP has been emailed to <span class="text-blue">{{ this.email }}</span>.<br> Please enter it below to proceed.</p>
                <p style="font-size: 1rem;" class="m-0 mt-2">Haven’t received an email?
                    <button [disabled]="otpResendDuration == 0 ? '' : 'disabled'" class="d-inline btn-link border-0 bg-white p-0" style="font-size: 0.9rem;" (click)="resendOTP()">
                        Resend OTP
                        <span *ngIf="resendOtpLoading" class="spinner-border spinner-border-sm ml-2"></span>
                        <fa-icon class="ml-2" [icon]="faCheckCircle" *ngIf="resendSuccessful" size="lg" ></fa-icon>
                    </button>
                </p>
                <p *ngIf="otpResendDuration !== 0" style="font-size: 1rem;" class="m-0 mt-1">You can resend OTP after {{ otpResendDuration }} seconds.</p>
                <p style="font-size: 1rem;" class="m-0 mt-2">In case you entered an incorrect email, please click 'Go Back'.
            </div>
            <hr class="m-0">
            <div class="d-flex p-4">
                <input class="flex-fill" type="text" (input)="verificationOTPConsentChange($event.target.value)">
                <button type="button" class="btn btn-sm btn-primary ml-3 px-3" [attr.disabled]="otpVerifyDisabled ? true : null" (click)="verifyOTP()">
                    <span style="visibility: hidden;">a</span>
                    <span *ngIf="verifyOtpLoading" class="spinner-border spinner-border-sm mr-1"></span>
                    Verify
                    <span style="visibility: hidden;">a</span>
                </button>
                <button class="btn btn-sm btn-outline-primary ml-3 px-3" (click)="closeModal(true)">Go Back</button>
            </div>
        </div>
    </ng-template>

    <ng-template #successfulRegistrationModal  let-modal>
        <div>
            <h4 [ngClass]="{'d-none': successfulRegistrationModalStepOne === false}" class="font-weight-bold p-4 m-0">Registration Successful</h4>
            <h4 [ngClass]="{'d-none': successfulRegistrationModalStepOne === true}" class="p-4 m-0">NCache Server Deployment</h4>
            <hr class="m-0">
            <div [ngClass]="{'d-none': successfulRegistrationModalStepOne === false}" class="p-4" style="height: 40vh; overflow-y: auto;">
                <p style="font-size: 1.2rem;">
                  You have successfully registered for {{cloudPlanResponse.productName}} {{cloudPlanResponse.cloudPlan.title}}
                </p>
                <p style="font-size: 1.2rem;">
                   <span *ngIf="isAzureVendor()" >NCache is Free. You <span class="text-red">only pay for underlying infrastructure</span> directly to Azure.</span>
                   <span *ngIf="!isAzureVendor()">NCache is Free. You <span class="text-red">only pay for underlying infrastructure</span> directly to AWS.</span>
                   <br>
                    <span *ngIf="this.freeTrialExpiry === ''">
                        Your free trial period will start when you deploy your first server.
                    </span>
                    <span *ngIf="this.freeTrialExpiry != ''">
                        The trial ends on {{this.freeTrialExpiry}}.
                    </span>
                </p>
            </div>
            <div [ngClass]="{'d-none': successfulRegistrationModalStepOne === true}" class="p-4" style="height: 40vh; overflow-y: auto;">
                <p style="font-size: 1.1rem;">Choose one of following methods to move forward with server deployment:</p>
                <form [formGroup]="redirectModelForm" class="px-4">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input type="radio" class="form-check-input" [value]="true"
                                formControlName="deplymentModalOption">
                            <h6><b>Automatic Deployment</b></h6>
                            <p class="ml-1 text-secondary" style="font-size:1rem;">
                                - Quickly deploy through NCache Cloud Portal<br>
                                - Requires deployment user creation
                            </p>
                        </label>
                    </div>
                    <div class="form-check">
                        <label class="form-check-label">
                            <input type="radio" class="form-check-input" [value]="false"
                                formControlName="deplymentModalOption">
                            <h6><b>Manual Deployment</b></h6>
                            <p class="ml-1 text-secondary" style="font-size:1rem;">
                              <ng-container *ngIf="isAzureVendor()">
                                - Deploy with CLI through ARM template<br>
                              </ng-container>
                              <ng-container *ngIf="!isAzureVendor()">
                                - Deploy with CLI through CloudFormation template<br>
                              </ng-container>
                            </p>
                        </label>
                    </div>
                </form>
                <p class="text-size-1" *ngIf="this.isAzureVendor"><a target="_blank" href="https://www.alachisoft.com/resources/docs/ncache/getting-started-cloud-service/deployment-methods-azure.html">Click here</a> for more details on deployment methods.</p>
                <p class="text-size-1" *ngIf="!this.isAzureVendor"><a target="_blank" href="https://www.alachisoft.com/resources/docs/ncache/getting-started-cloud-service/deployment-methods-aws.html">Click here</a> for more details on deployment methods.</p>
            </div>
            <hr class="m-0">
            <div class="d-flex justify-content-end p-4">
                <button class="btn btn-sm btn-primary btn-nc mr-4" (click)="successfulRegistrationModalNext(successfulRegistrationModalStepOne ? 1 : 2)">
                    Next >
                </button>
                <button class="btn btn-sm btn-outline-primary btn-nc" (click)="redirectToDashboard()">
                    Go to Dashboard
                </button>
            </div>
        </div>
    </ng-template>

    <ng-template #successfulRegistrationPaidModal>
        <div class="modal-header px-4">
          <h6 class="modal-title" id="confirm-purchase-otp-verification-modal">
            <b>Subscription Created</b>
          </h6>
        </div>
        <div class="modal-body px-4 pb-2">
            <p class="mb-4">Your <strong>{{cloudOfferDisplayName}}</strong> subscription has successfully been created.</p>
        </div>
        <div class="d-flex justify-content-end p-4">
            <button class="btn btn-sm btn-primary px-3" (click)="resolveAuthToken()">
                <span *ngIf="this.otpVerificationModal" class="me-1" role="status" aria-hidden="true"></span>Continue</button>
        </div>
    </ng-template>

      <ng-template #otpVerificationModal let-modal>
        <div class="modal-header px-4">
            <h5 class="modal-title" id="confirm-purchase-otp-verification-modal">
              <b>Verify Email Address</b>
            </h5>
          </div>
          <div class="modal-body px-4 pb-2">
            <p class="m-0">A verification OTP has been emailed to <span class="text-primary">{{ this.email }}</span>.<br> Please enter it below to proceed.</p>
    
            <p class="m-0 mt-3">Haven’t received an email?
              <button
                [disabled]="this.otpResendDuration !== 0"
                class="d-inline btn btn-link border-0 p-0"
                style="font-size: 0.9rem;"
                (click)="resendOTP()">
                Resend OTP
                <span *ngIf="isOTPResendLoading" class="spinner-border spinner-border-sm ms-2"></span>
                <fa-icon class="ms-2" [icon]="faCheckCircle" *ngIf="this.resendSuccessful" size="lg" style="color: green;"></fa-icon>
              </button>
            </p>
            <p *ngIf="this.otpResendDuration !== 0" class="m-0 mt-2">You can resend OTP after {{this.otpResendDuration}} seconds.</p>
          </div>
          <div class="d-flex flex-row align-items-center gap-3 p-4 pt-2">
            <input
              class="form-control form-control-sm flex-grow-1 border border-2"
              type="text"
              [(ngModel)]="verificationOTP"
              (ngModelChange)="toggleOTPBtn()"
            />
            <button
              type="button"
              class="btn btn-sm btn-primary px-5"
              [attr.disabled]="isOtpVerifyDisabled ? true : null"
              (click)="verifyOTP()">
              <span *ngIf="isOtpVerificationLoading" class="spinner-border spinner-border-sm me-1"></span>
              Verify
            </button>
          </div>
    </ng-template>
</app-content-body>
